/*
 * @Descripttion:
 * @Version: 1.0
 * @Author: 张家彬
 * @Date: 2024-05-07 18:22:10
 * @LastEditors: 张家彬
 * @LastEditTime: 2024-07-05 11:12:47
 */

import { proxy } from 'umi';

const state = proxy({
  selectedKeys: ['/besp'],
  layoutActionRef: null,
  refreshPage: true,
});

export default state;
